module.exports = __webpack_public_path__ + "static/frn-wlc-ah-white.0cb3c7f1.svg";